import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "no-categories-found"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-warning" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" No category available for display. ")
], -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "categories__renderer",
  "element-loading-text": "Generating Categories List"
}
const _hoisted_5 = { class: "categories__Items" }
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return ($props.categories && $props.categories.length == 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.categories, (category) => {
            return (_openBlock(), _createElementBlock("li", {
              key: category.id,
              class: "categories__lists",
              onClick: ($event: any) => ($options.categorySelected(category))
            }, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { md: 20 }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, _toDisplayString(category.category_name), 1 /* TEXT */),
                      _createElementVNode("p", null, _toDisplayString(category.path_name), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1024 /* DYNAMIC_SLOTS */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ], 8 /* PROPS */, _hoisted_6))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])), [
        [_directive_loading, $props.loading]
      ])
}